












import { BButton } from "bootstrap-vue";
import { onClickOutside } from "@vueuse/core";
import { ref } from "@vue/composition-api";
import { VEmojiPicker } from "v-emoji-picker";
import { IEmoji } from "v-emoji-picker/lib/models/Emoji";

export default {
    components: {
        BButton,
        VEmojiPicker,
    },
    // @ts-ignore
    setup(props, { emit }) {
        const emojiPicker = ref(null);
        const showEmojiPicker = ref(false);

        onClickOutside(emojiPicker, () => (showEmojiPicker.value = false));

        const selectEmoji = (emoji: IEmoji) => {
            showEmojiPicker.value = false;
            emit("select-emoji", emoji);
        };

        return {
            emojiPicker,
            showEmojiPicker,
            selectEmoji,
        };
    },
};
